const OER_ICONS = {
  HARSH_BRAKING: 'suddenstop',
  SUDDEN_STOP: 'suddenstop',
  RULEHARSHBRAKINGID: 'suddenstop',

  AGGRESSIVE_ACCELERATION: 'suddenstart',
  SUDDEN_START: 'suddenstart',
  RULEJACKRABBITSTARTSID: 'suddenstart',

  HEADWAY: 'headway',
  HEADWAY_MONITORING: 'headwaymonitoring',

  RULEACCIDENTID: 'collisionmit',
  MERITOR_ONGUARD_COLLISION_MITIGATION: 'collisionmit',
  COLLISION_MITIGATION: 'collisionmit',
  FRONTAL_COLLISION_PREDICTION: 'collisionmit',

  STABILITY_CONTROL_7: 'forwardcol',

  PANIC: 'panic',
  DISTRESS: 'panic',

  MANUAL: 'manual',

  RULEHARSHCORNERINGID: 'harshturn',
  ROP_ENGINE_CONTROL: 'harshturn',
  ROP_BRAKE_CONTROL: 'harshturn',
  HARD_CORNERING: 'harshturn',

  OOT_SESSION_EXPIRED: 'oot',

  FATIGUE: 'fatigue',

  CELLPHONE_USAGE: 'cellphoneusage',

  EXCESSIVE_SPEEDING: 'excessivespeed',
  EXCESSIVE_SPEED: 'excessivespeed',

  DRIVER_DISTRACTION: 'driverdistraction',

  DRIVER_SMOKING: 'driversmoking',

  SEAT_BELT_USAGE: 'seatbeltusage',

  CAMERA_BLOCKED: 'coveredcamera',

  LANE_DEPARTURE: 'lanedeparture',

  FORWARD_COLLISION_WARNING: 'forwardcollisionwarning'
};

export const getOerIconName = oerTrigger => {
  if (!oerTrigger) {
    return 'oergeneral';
  }

  const icon = OER_ICONS[oerTrigger.toUpperCase()];
  return icon || 'oergeneral';
};
